import { useKestrel } from 'features/kestrelViewer/KestrelProvider'
import { useEffect, useState } from 'react'
import { KVAnnotation } from 'types'

export type SortedAnnotationsReturnType = {
  ungroupedMarkups: KVAnnotation[]
  groupedMarkups: {
    [key: string]: KVAnnotation[]
  }
  count: number
}

export const useSortedAnnotations = (
  annotations: KVAnnotation[],
  tag: string
) => {
  const { inspectionType } = useKestrel()

  const [sortedAnnotations, setSortedAnnotations] =
    useState<SortedAnnotationsReturnType>({
      ungroupedMarkups: [],
      groupedMarkups: {},
      count: 0,
    })

  function sortAnnotations(
    markups: KVAnnotation[],
    tag: string
  ): SortedAnnotationsReturnType {
    const groupedMarkups: { [key: string]: KVAnnotation[] } = {}
    const ungroupedMarkups: KVAnnotation[] = []
    const count = markups.length

    if (!tag) {
      return {
        groupedMarkups,
        ungroupedMarkups: markups.sort((a, b) =>
          a.label.localeCompare(b.label)
        ),
        count,
      }
    }

    for (const markup of markups) {
      if (!markup.tags || !markup.tags[tag] || !markup.tags[tag].value) {
        ungroupedMarkups.push(markup)
      } else {
        if (groupedMarkups[markup.tags[tag].value]) {
          groupedMarkups[markup.tags[tag].value].push(markup)
        } else {
          groupedMarkups[markup.tags[tag].value] = [markup]
        }
      }
    }

    return { ungroupedMarkups, groupedMarkups, count }
  }

  useEffect(() => {
    const sortedData = sortAnnotations(annotations, tag)
    setSortedAnnotations(sortedData)
  }, [annotations, inspectionType, tag])

  return {
    sortedAnnotations,
  }
}
